"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var Title_1 = __importDefault(require("../Title"));
function CarOptions(props) {
    var userMetadata = props.userMetadata, title = props.title;
    var options = userMetadata && 'additional_characteristics' in userMetadata
        ? userMetadata.additional_characteristics
        : undefined;
    var hasOptions = options && options.length;
    return hasOptions ? (react_1.default.createElement("div", { className: "azgazui__options" },
        react_1.default.createElement("div", { className: "container" },
            react_1.default.createElement(Title_1.default, { level: "h2" }, title),
            react_1.default.createElement("ul", null, options.map(function (option) { return (react_1.default.createElement("li", { key: option }, option)); }))))) : null;
}
exports.default = CarOptions;
CarOptions.displayName = 'CarOptions';
CarOptions.propTypes = {
    userMetadata: prop_types_1.default.objectOf(prop_types_1.default.any),
    title: prop_types_1.default.string.isRequired,
};
CarOptions.defaultProps = {
    userMetadata: undefined,
};
